import countBy from 'lodash/countBy';
import maxBy from 'lodash/maxBy';
import toPairs from 'lodash/toPairs';
import last from 'lodash/last';
import head from 'lodash/head';
import { ComplexSelection } from '@/features/Sparten/shared/schema/provident/providentInputSchema';

export const complexSelectionFormatter = (
  selection: ComplexSelection[] | string,
) => {
  if (!Array.isArray(selection)) {
    return selection;
  }

  if (selection.length === 0) {
    return 'Keine Auswahl';
  }

  // Based on https://stackoverflow.com/a/18878650/1397894
  const scores = countBy(selection, 'value');
  const sorted = maxBy(toPairs(scores), last);

  return head(sorted);
};
